import React from 'react'

import {
  Box,
  Display,
  AlignItems,
  FlexDirection,
  JustifyContent,
  Color,
  TextAlign,
  Text,
  FontFamily,
  Heading1,
  FontWeight,
} from '@gousto-internal/citrus-react'

import { RafCampaignDetails } from '../../../hooks/useFetchRafCampaignDetails'
import styled from '@emotion/styled'

const SecondDiscount = styled(Box)`
  box-sizing: border-box;
  width: calc(100% - 36px);
`

const ThirdDiscount = styled(Box)`
  margin-left: 72px;
  box-sizing: border-box;
  width: calc(100% - 72px);
`

export const DiscountBoxesThreeTier = ({
  firstBoxDiscount,
  firstMonthDiscount,
  secondBoxDiscount,
}: Omit<RafCampaignDetails, 'giftYourFriendCredit'>) => (
  <Box
    display={Display.Flex}
    flexDirection={[FlexDirection.Row, null, FlexDirection.Column]}
    alignItems={[AlignItems.Center, null, AlignItems.FlexEnd]}
    gap={2}
    style={{ width: '266px' }}
  >
    <Box
      bg={Color.Primary_600}
      paddingH={10}
      paddingV={6}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
      borderRadius={1}
      width={'100%'}
    >
      <Box display={Display.Flex} flexDirection={FlexDirection.Row} alignItems={AlignItems.Center}>
        <Heading1
          color={Color.White}
          display={Display.Inline}
          fontFamily={FontFamily.Bold}
          style={{ fontSize: '108px', lineHeight: '108px' }}
          data-testid="raf-first-box-discount"
        >
          {firstBoxDiscount}
        </Heading1>
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          alignItems={AlignItems.FlexStart}
          justifyContent={JustifyContent.Center}
          paddingV={2}
        >
          <Text
            color={Color.White}
            display={Display.Inline}
            fontWeight={FontWeight.Bold}
            style={{ fontSize: '56px', lineHeight: '56px' }}
          >
            %
          </Text>
          <Text color={Color.White} display={Display.Inline} fontWeight={FontWeight.Bold} size={9}>
            OFF
          </Text>
        </Box>
      </Box>
      <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
        <Text
          color={Color.White}
          size={9}
          textAlign={TextAlign.Center}
          fontWeight={FontWeight.SemiBold}
          style={{ lineHeight: '32px' }}
        >
          1st box
        </Text>
      </Box>
    </Box>
    <SecondDiscount
      bg={Color.ColdGrey_800}
      paddingV={4}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
      borderRadius={1}
    >
      <Box display={Display.Flex} flexDirection={FlexDirection.Row} alignItems={AlignItems.Center}>
        <Text
          color={Color.White}
          display={Display.Inline}
          fontFamily={FontFamily.Bold}
          style={{ fontSize: '64px', lineHeight: '64px' }}
          data-testid="raf-second-box-discount"
        >
          {secondBoxDiscount}
        </Text>
        <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
          <Text
            color={Color.White}
            display={Display.Inline}
            fontWeight={FontWeight.Bold}
            size={13}
            style={{ lineHeight: '32px' }}
          >
            %
          </Text>
          <Text
            color={Color.White}
            display={Display.Inline}
            fontWeight={FontWeight.Bold}
            size={5}
            style={{ lineHeight: '14px' }}
          >
            OFF
          </Text>
        </Box>
      </Box>

      <Text color={Color.White} size={5} textAlign={TextAlign.Center} fontWeight={FontWeight.Bold}>
        2nd box
      </Text>
    </SecondDiscount>
    <ThirdDiscount
      bg={Color.ColdGrey_800}
      paddingV={4}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
      borderRadius={1}
    >
      <Box display={Display.Flex} flexDirection={FlexDirection.Row} alignItems={AlignItems.Center}>
        <Text
          color={Color.White}
          display={Display.Inline}
          fontFamily={FontFamily.Bold}
          style={{ fontSize: '64px', lineHeight: '64px' }}
          data-testid="raf-first-month-discount"
        >
          {firstMonthDiscount}
        </Text>
        <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
          <Text
            color={Color.White}
            display={Display.Inline}
            fontWeight={FontWeight.Bold}
            size={13}
            style={{ lineHeight: '32px' }}
          >
            %
          </Text>
          <Text
            color={Color.White}
            display={Display.Inline}
            fontWeight={FontWeight.Bold}
            size={5}
            style={{ lineHeight: '14px' }}
          >
            OFF
          </Text>
        </Box>
      </Box>
      <Text
        color={Color.White}
        size={4}
        textAlign={TextAlign.Center}
        fontWeight={FontWeight.Normal}
      >
        all boxes in your first <br /> two months
      </Text>
    </ThirdDiscount>
  </Box>
)
